import { supabase } from "@/integrations/supabase/client";

/**
 * Dispara os e-mails "conta criada" e "boas-vindas" ao finalizar o onboarding (chamar após "Finalizar").
 * A função edge é idempotente (marca `onboarding_welcome_emails_sent_at`).
 */
export async function sendOnboardingCompleteEmails(): Promise<void> {
  const { error } = await supabase.functions.invoke(
    "send-onboarding-complete-emails",
  );
  if (error) {
    console.error("[send-onboarding-complete-emails]", error);
  }
}
